<template>
  <div class="content" style="display: flex">
    <!-- 标签 -->
    <div class="back-color-fff borderR6 menu-tab" v-loading="tagsLoading">
      <el-select v-model="pageTag.tenantGuid" placeholder="请选择" filterable @change="getDept" class="w100f">
        <el-option
          v-for="item in tenantList"
          :key="item.sendTenantGuid"
          :label="item.sendTenantName"
          :value="item.sendTenantGuid">
        </el-option>
      </el-select>
      <el-input placeholder="输入关键字搜索" v-model="pageTag.deptName" class="tab-input mt10" @input="tagChange()" clearable>
      </el-input>
      <el-button icon="el-icon-plus" class="w100f mt10 mb15" @click="addTagsList()">添加科室分类</el-button>
      <div class="tags-list-left-box">
        <div
          :class="tagsGuid == item.guid ? 'tags-list tags-active' : 'tags-list'"
          v-for="(item, index) in tagsList"
          :key="index"
          @click="tagsSelect(item, index)"  
        >
          <div class="tags-list-left">
            <el-input v-model="item.deptName"  v-if="item.btnSh" placeholder="请输入" @input="changeDeptName(item.deptName)"></el-input>
            <span v-if="!item.btnSh"> {{ item.deptName }}</span>
          </div>
          <div class="tags-list-right">
            <img class="tags-edit" v-if="!item.btnSh" @click.stop="editTagsList(item,index)" src="../../assets/images/tab_edit.png" alt="" />
            <img class="tags-save" v-if="item.btnSh" @click.stop="saveTagsList(item)" src="../../assets/images/tab_save.png" alt="" />
            <img class="tags-del" @click.stop="tagsDel(item.guid,index)" src="../../assets/images/tab_delete.png" alt="" />
          </div>
        </div> 
      </div>
      <div v-if="!tagsList" class="tags-list">暂无分类数据</div>
      <el-pagination
        :current-page="pageTag.pageIndex"
        :page-size="pageTag.pageSize"
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="pageTag.totalRows"
        small
        :pager-count="5"
      >
      </el-pagination>
    </div>
    <div class="right-content-box back-color-fff"> 
      <div class="search-area">
        <div class="search-area-top">{{copyData.className}}（{{page.totalRows}}个科室）</div>
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="search-area-div">科室名称：</div>
            <el-input v-model="page.deptName" class="ipt-sty" placeholder="请输入报表名称"></el-input>
          </el-col>
          <el-col :span="6">
            <div class="mt32">
              <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
              <el-button size="mini" type="danger" @click="empty">清空</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
        <div class="button-area">
          <el-button class="fl" v-if="getBtnPermissionsByName('添加科室')" icon="el-icon-plus" size="mini" type="info" @click="add(1, '')">添加科室</el-button>
          <el-button class="fl" v-if="getBtnPermissionsByName('复制科室')" size="mini" type="info" @click="getCopyData()">复制科室</el-button>
          <el-button class="fl" v-if="getBtnPermissionsByName('批量删除')" size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
          <el-button class="fl" v-if="getBtnPermissionsByName('分类排序')" size="mini" type="info" @click="sortShow(1)">分类排序</el-button> 
          <el-button class="fl" v-if="getBtnPermissionsByName('科室排序')" size="mini" type="info" @click="sortShow(2)">科室排序</el-button> 
        </div>
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          stripe
          border
          style="width: 100%;"
          :height="tableHeight"
          class="drag-table"
          v-loading="tableLoading"
          row-key="guid" 
        >
          <el-table-column type="selection" width="40" header-align="center" align="center"></el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="科室名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="sort"
            label="科室排序"
            header-align="center"
            align="left"
            width="80"
            show-overflow-tooltip
          ></el-table-column> 
          <el-table-column label="操作" header-align="center" align="center" width="170">
            <template slot-scope="scope">
              <a class="txt-color" v-if="getBtnPermissionsByName('编辑')" @click="add(2, scope.row)">编辑 | </a>
              <a class="txt-color-red"  v-if="getBtnPermissionsByName('删除')" @click="getDeleteData(2, scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div> 
    <!-- 新增/编辑标签弹框 -->
    <el-dialog :title="textTitle" top="35vh" :visible.sync="dialogVisible1" width="600px" :close-on-click-modal="false">
      <div class="edit-tags-text">
        <label class="w100 line-h30"><span class="fontC-red">*</span>名称：</label>
        <el-input placeholder="请输入" v-model="tagForm.deptName" @input="changeDeptName(tagForm.deptName)"> </el-input>
      </div>
      <div class="edit-tags-text" v-if="textTitle == '编辑科室'">
        <label class="w100 line-h30"><span class="fontC-red">*</span>排序：</label>
        <el-input placeholder="请输入序号" type="number" v-model="tagForm.sort"> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogVisible1 = false">取消</el-button>
        <el-button size="mini" type="info" @click="submitTags()">确定</el-button>
      </div>
    </el-dialog> 
    <el-dialog title="复制科室" top="35vh" :visible.sync="dialogVisible2" width="600px" :close-on-click-modal="false">
      <div class="edit-tags-text ml10">
        说明：该功能支持将科室数据同步应用给其他公司使用。
      </div>
      <div class="edit-tags-text">
        <label class="w100"><span class="fontC-red">*</span>所选科室：</label>
        {{copyData.deptNames}}
      </div>
      <div class="edit-tags-text">
        <label class="w100 line-h30"><span class="fontC-red">*</span>应用公司：</label>
        <el-select v-model="tenantGuids" placeholder="请选择" filterable multiple collapse-tags class="w100f">
          <el-option
            v-for="item in tenantList1"
            :key="item.sendTenantGuid"
            :label="item.sendTenantName"
            :value="item.sendTenantGuid">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogVisible2 = false">取消</el-button>
        <el-button size="mini" type="info" @click="copyMedDept()" v-loading.fullscreen.lock="fullscreenLoading">确定</el-button>
      </div>
    </el-dialog> 
   
    <!-- 排序组件-->
    <DraggableTable ref="draggableTable" :title="sortTitle" :list="sortList" @sortEnd="sortEnd"></DraggableTable>
  </div>
</template>
<script>
import btnPermisson from '../mixins/btnPermisson';
import DraggableTable from '@/components/draggableTable.vue';
export default {
  mixins:[btnPermisson],
  components: {
    DraggableTable
  },
  data() {
    return {
      tableHeight: window.innerHeight - 300,
      contentMainHeight: window.innerHeight - 250,
      tenantGuids:'',
      tenantList:[],
      tenantList1:[],//复制科室时使用的企业列表
      textTitle: '添加科室', 
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        classType: 2,
        parentGuid: '',
        tenantGuid: '',
      },
      tableData: [],//右边表格
      multipleSelection: [],
      multipleSelectionGuid: [],
      tableLoading: false,
      dialogVisible1: false,//编辑科室
      dialogVisible2: false,//复制科室
      fullscreenLoading: false,
      tagsList: [],//左边标签
      tagsGuid: '',
      pageTag: {
        pageIndex: 1,
        pageSize: 10,
        deptName: '',
        classType: 1,
        tenantGuid: '',
      },
      //标签名称
      tagForm: {
        guid: '',
        parentGuid: '',
        deptName: '',
        classType: 2,
        sort: '',
      },
      copyData: {
        useTenantGuids: [],
        className: '',
        deptNames: '',
        tenantGuid: ''
      },
      tagsLoading: false,
      showSort:false,//排序弹窗
      sortList:[],//排序列表
      sortTitle:'分类排序',
      sortClassType:null
    };
  },
  created() {
    // 列表
    // this.getData(false);
    this.getTenantOperationRelList();
    //按钮权限
    this.getMenuList();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/addReport" || to.path == "/lookReportpage") {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    async sortShow(flg){
      let self=this
      this.sortClassType=flg
      if(flg==1){
        this.sortTitle='分类排序'
        // this.getTagsList(true)
        
      }else{
        console.log(this.copyData.className);
        this.sortTitle='【' + this.copyData.className + '】' + '科室排序'
        // this.sortList = JSON.parse(JSON.stringify(this.allGroupData))
      }
      if(!self.pageTag.tenantGuid){
        self.$message.error('请选择公司！');
        return
      }
      let param={
        pageIndex: 1,
        pageSize: -1,
        deptName: '',
        classType: flg, 
        tenantGuid: self.pageTag.tenantGuid,
      }
      if(flg==2){
        param.parentGuid=this.tagsGuid
      }
      console.log('sortShow',param);
      this.sortList = []
      this.sortList = await this.getSortList(param)
      this.$nextTick(()=>{
        this.$refs.draggableTable.showSort = true;
      })
    },
    getSortList(param) {
      return new Promise((resolve,reject)=>{
        this.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/list`, param).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let list = res.data.data.records||[]
            resolve(list)
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
    },
    sortEnd(list){
      console.log('lll',list);
      this.sortList=list
      this.fullscreenLoading=true
      // 发请求
      this.api.put(`/${serverConfig.msPersonnelService}/med-dept/update-sort?classType=${this.sortClassType}`,this.sortList ).then((res) => {
        this.fullscreenLoading=false
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$refs.draggableTable.showSort = false
          if(this.sortClassType==1){
            this.getTagsList(true)
          }else{
            this.getData(true);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
      
    },
    
    //标签
    tagChange() {
      // if(this.pageTag.labelName){
      this.getTagsList();
    },
    getTenantOperationRelList(){ 
      let self = this; 
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true&isShowSupper=true`+'&tenantGuid='+localStorage.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tagsLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            self.tenantList1 = res.data.data; 
            if(self.tenantList && self.tenantList.length > 0){
              self.pageTag.tenantGuid = self.tenantList[0].sendTenantGuid;
              self.getTagsList();
            }
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取标签列表
    getTagsList(flg) {
      let self = this;
      self.tagsLoading = true; 
      if(!self.pageTag.tenantGuid){
        self.$message.error('请选择公司！');
        return
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/list`,self.pageTag).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tagsLoading = false; 
          self.tagsList = res.data.data.records||[];
          self.pageTag.totalRows = res.data.data.totalRows;
          if(self.tagsList && self.tagsList.length > 0){
            self.tagsGuid = self.tagsList[0].guid;
            this.copyData.className = self.tagsList[0].deptName,
            self.tagForm.parentGuid = self.tagsList[0].guid;
            self.tagForm.tenantGuid = self.tagsList[0].tenantGuid; 
            self.page.parentGuid = self.tagsList[0].guid;
            self.page.tenantGuid = self.tagsList[0].tenantGuid;
            self.tagsList.forEach((i)=>{
              i.btnSh = false;
            })
            self.getData(true);
          }else{
            self.tagsList = [];
            self.page.tenantGuid = '';
            self.page.parentGuid = '';
            self.tableData = [];
          }
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //添加标签
    addTagsList() {
      let item = {
        deptName:'',
        guid:'',
        num:'',
        btnSh:true
      }
      this.tagsList.push(item);
    },
    editTagsList(item,index){
      this.tagsList[index].btnSh = true;
      this.$forceUpdate()
    },
    saveTagsList(item) {
      let self = this;  
      if(!item.deptName){
        this.$message.error('请输入科室分类名称！');
        return
      }
      let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im; 
      if (patrn.test(item.deptName)) {// 如果包含特殊字符返回false
        this.$message.error('请输入中文、字母、数字，最多20个字的名称！');
        return
      } 
      if(item.guid){
        let promise = {
          guid: item.guid,
          tenantGuid: item.tenantGuid,
          deptName: item.deptName,
          sort: item.sort,
          classType: item.classType,
          serviceTenantGuid:localStorage.guid
        }; 
        this.api.put(`/${serverConfig.msPersonnelService}/med-dept/update`,promise).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('修改成功！'); 
            this.getTagsList(); 
          } else {
            this.fullscreenLoading = false;
            this.$message.error(res.data.msg);
          }
        });
      }else{
        let promise = {
          tenantGuid: self.pageTag.tenantGuid,
          deptName: item.deptName,
          classType: 1,
          serviceTenantGuid:localStorage.guid
        };
        self.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/add`,promise).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
            self.$message.success('添加成功');
            self.getTagsList();
          } else {
            self.$message.error(res.data.msg);
          }
        }); 
      }
    },
    //选中标签
    tagsSelect(item, index) {
      if(!item.deptName){
        return
      }
      this.tagsGuid = item.guid;
      this.copyData.className = item.deptName,
      this.tagForm.parentGuid = item.guid;
      this.tagForm.tenantGuid = item.tenantGuid; 
      this.page.parentGuid = item.guid;
      this.page.tenantGuid = item.tenantGuid;
      this.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if(!self.page.tenantGuid){
        return
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/list`,self.page).then(res => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records||[];  
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDept(){
      this.page.tenantGuid = '';
      this.page.parentGuid = '';
      this.page.totalRows = 0;
      this.getTagsList();
    }, 
    add(flg, row) {
      let self = this; 
      if (flg == 1) {
        self.dialogVisible1 = true;
        self.textTitle = "添加科室"; 
        self.tagForm.guid = '',
        self.tagForm.deptName = '';
        self.tagForm.sort = '';
      } else {
        self.dialogVisible1 = true;
        self.textTitle = "编辑科室";
        self.tagForm.guid = row.guid;
        self.tagForm.parentGuid = row.parentGuid;
        self.tagForm.tenantGuid = row.tenantGuid; 
        self.tagForm.deptName = row.deptName;
        self.tagForm.sort = row.sort;
      } 
    }, 
    //提交标签编辑
    submitTags() {
      let self = this;
      if (this.tagForm.deptName == '') {
        this.$message.error('请输入名称！');
        return;
      } 
      let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im; 
      if (patrn.test(this.tagForm.deptName)) {// 如果包含特殊字符返回false
        this.$message.error('请输入中文、字母、数字，最多20个字的名称！');
        return
      }  
      if (this.tagForm.guid) {
        if (this.tagForm.sort === '') {
          this.$message.error('请输入排序！');
          return;
        } 
        let promise = {
          guid: this.tagForm.guid,
          parentGuid: this.tagForm.parentGuid,
          tenantGuid: this.tagForm.tenantGuid,
          deptName: this.tagForm.deptName,
          sort: this.tagForm.sort,
          classType: 2
        };
        this.fullscreenLoading = true;
        this.api.put(`/${serverConfig.msPersonnelService}/med-dept/update`,promise).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success(this.textTitle + '成功！');
            this.fullscreenLoading = false;
            this.getData(false);
            this.dialogVisible1 = false;
          } else {
            this.fullscreenLoading = false;
            this.$message.error(res.data.msg);
          }
        });
      }else{
        let promise = {
          // guid: this.tagForm.guid,
          parentGuid: this.tagForm.parentGuid,
          tenantGuid: this.tagForm.tenantGuid,
          deptName: this.tagForm.deptName,
          sort: this.tagForm.sort,
          classType: 2
        };
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/add`,promise).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success(this.textTitle + '成功！');
            this.fullscreenLoading = false;
            this.getData(true);
            this.dialogVisible1 = false;
          } else {
            this.fullscreenLoading = false;
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    //删除标签
    tagsDel(guid,index) {
      let self = this;
      if(guid){
        this.$confirm('删除后不可恢复，确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/del?classType=1`, [guid]).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                this.fullscreenLoading = false;
                this.getTagsList();
              } else {
                self.$message.error(res.data.msg);
                this.fullscreenLoading = false;
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
            this.fullscreenLoading = false;
          });
      }else{
        this.tagsList.splice(index,1);
        this.getTagsList();
      } 
    },
    handleClick(tab, event) {
      console.log(tab.name);
      if (tab.name == 'first') {
        this.$router.push({ path: '/dataSource',query:{ productGuid:this.$route.query.productGuid} });
      } else if (tab.name == 'second') {
        this.$router.push({ path: '/dimensionManagement' ,query:{ productGuid:this.$route.query.productGuid}});
      } else {
        this.$router.push({ path: '/reportManagement',query:{ productGuid:this.$route.query.productGuid} });
      }
    },
    empty() {
      let self = this;
      self.page.pageIndex = 1;
      self.page.pageSize = 10;
      self.page.totalPage = 0;
      self.page.totalRows = 0;
      self.page.deptName = '';
      // self.tagsGuid = '';
      self.getData(true);
    }, 
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.deptName);
        self.multipleSelectionGuid.push(item.guid);
      });
    },
    getCopyData(){
      let self = this;
      if (self.multipleSelection.length == 0) {
        self.$message.error('请勾选数据！');
        return
      }else{
        let deptNames = '';
        self.tenantGuids = [];
        self.tenantList1.forEach((j,index)=>{
          if(j.guid == self.pageTag.tenantGuid){
            self.tenantList1.splice(index,1);
          }
        })
        self.multipleSelection.forEach((i,index)=>{
          if(index < 2){
            deptNames = deptNames + i + ','
          } 
        })
        deptNames= deptNames.substring(0,deptNames.length - 1);
        if(self.multipleSelection.length > 2){
          self.copyData.deptNames = self.copyData.className + ' - ' + deptNames + '等'+ self.multipleSelection.length +'个科室'
        }else{
          self.copyData.deptNames = self.copyData.className + ' - ' + deptNames
        }
      } 
      self.dialogVisible2 = true;
    },
    copyMedDept(){ 
      let self = this;
      let promise = {
        useTenantGuids: self.tenantGuids,
        className: self.copyData.className,
        deptNames: self.multipleSelection,
        tenantGuid: self.pageTag.tenantGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/copy-med-dept`,promise).then(res => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible2 = false;
          self.$message.success('复制成功');
          self.getData(false);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelectionGuid.length == 0) {
          self.$message.error('请勾选数据！');
          return
        }
      } else {
        self.multipleSelectionGuid = [];
        self.multipleSelectionGuid.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msPersonnelService}/med-dept/del?classType=2`, self.multipleSelectionGuid).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.multipleSelectionGuid = [];
              self.$message.success('删除成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.pageTag.pageSize = val;
      this.getTagsList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.pageTag.pageIndex = val;
      this.getTagsList();
    },
    handleSizeChange1(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    changeDeptName(deptName){
      var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im; 
      if (patrn.test(deptName)) {// 如果包含特殊字符返回false
        this.$message.error('请输入中文、字母、数字，最多20个字的名称！');
        return
      } 
    },
  },
};
</script>
<style scoped>
/* 选项卡 */
.menu-tab {
  width: 240px;
  padding: 15px;
  box-sizing: border-box;
  border-right: 1px solid #D9D9D9
}
.tags-list-left-box {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}
.tags-edit {
  width: 20px;
  margin-top: 2px;
  margin-right: 10px;
}
.tags-save{    
  width: 18px;
  height: 17px;
  margin-right: 11px;
}
.tags-del {
  width: 16px;
  margin-top: 2px;
}
.tags-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 45px;
  /* line-height: 40px; */
  text-align: left;
  padding: 0 10px;
  cursor: pointer;
}
.tags-list-left {
  width: calc(100% - 60px);
  display: flex;
  align-items: center;
}
.tags-list-left span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tags-list:hover {
  background: rgb(245, 244, 244);
}
.tags-active {
  color: #4fa1a4 !important;
  background: rgb(245, 244, 244);
}
.edit-tags-text {
  /* padding: 0 40px; */
  display: flex;
  /* align-items: center; */
  margin-bottom: 20px;
}
.edit-tags-text label {
  width: 80px;
  flex-shrink: 0;
  text-align: right;
  padding-top: 2px;
}
.flex1 {
  flex: 1;
}
.button-area {
  display: flex;
  justify-content: flex-start;
  padding: 0 20px 10px 10px;
  margin-top: 0;
}
.content-main-box {
  overflow-y: visible;
}
/deep/ .el-tabs__item {
  height: 48px;
  line-height: 48px;
}
/deep/ .el-tabs__header {
  padding-left: 15px;
  position: relative;
  margin: 0;
}
/deep/ .el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: 0px;
  position: relative;
  width: 262px;
}
/deep/ .el-tabs__item.is-active {
  color: #649fa3;
  font-weight: 500;
}
/deep/ .el-tabs__item:hover {
  color: #649fa3;
  cursor: pointer;
}
/deep/ .el-tabs__active-bar {
  background-color: #649fa3;
}
.loading-box{
  position: fixed;
  width: calc(100% - 230px);
  height: 100%;
  top:52px;
  bottom:0;
  left: 230px;
  right: 10px;
  z-index: 9999999;
}
.tags-active {
  background: #eeeeee;
}
.search-area-top {
  /* height: 40px;
  line-height: 40px; */
  text-align: left;
  font-size: 18px;
  margin-bottom: 15px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield;
} 
/* /deep/.el-loading-spinner .circular{
  display: none!important;;
}
/deep/.el-loading-spinner {
  background-repeat: no-repeat;
  background-image:url('../../assets/images/loading_icon1.gif');
  background-size: 300px 300px;
  background-size: 350px 350px;
  background-image:url('../../assets/images/loading_icon2.gif');
  height:200px;
  width:100%;
  background-position:center;
  top:33%;
} */
.el-col-12{
  display: flex;
}
.el-col-6{
  display: flex;
}
.mt32{
  flex-shrink: 0;
}
.ipt-sty{
  flex:1;
}
.search-area-div{
  flex-shrink: 0;
  margin-right: 4px;
  text-align:right
}
</style>
